import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnInit,
  OnChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { matClose } from '@ng-icons/material-icons/baseline';
import { SpinnerComponent } from '../spinner/spinner.component';
import { FieldConfig } from '../dynamicform/dynamicform.component';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-searchable-select',
  standalone: true,
  imports: [CommonModule, FormsModule, NgIconComponent, SpinnerComponent, TranslocoModule],
  templateUrl: './searchable-select.component.html',
  styleUrls: ['./searchable-select.component.css'],
  providers: [provideIcons({ matClose })],
})
export class SearchableSelectComponent implements OnInit,OnChanges {
  @Input() field: FieldConfig = {} as FieldConfig;
  lastSearchTermTimes: number = 0;
  isDataLoading: boolean = true;

  ngOnInit(): void {
    this.isDataLoading = this.field.options === undefined || this.field.options.length === 0;
  }
  
  ngOnChanges(): void {
    this.isDataLoading = this.field.options === undefined || this.field.options.length === 0;
  }

  public closeListWithDelay(field: any): void {
    setTimeout(() => {
      field.listOpen = false;
    }, 200);
  }
  selectSearchableOption(field: any, option: any) {
    field.value = option.value;
    field.searchTerm = option.searchTerm;
    field.listOpen = false;
    field.activeOptionIndex = -1;
  }

  onSearchableSelectKeydown(event: KeyboardEvent, field: any) {
    if (event.key === 'ArrowDown') {
      event.preventDefault();

      if (
        field.activeOptionIndex === undefined ||
        field.activeOptionIndex === null ||
        field.activeOptionIndex >= field.options.length - 1
      ) {
        field.activeOptionIndex = 0;
      } else {
        field.activeOptionIndex++;
      }
      this.scrollToActiveOption(field);
      if (!field.listOpen) {
        field.listOpen = true;
      }
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      if (
        field.activeOptionIndex === undefined ||
        field.activeOptionIndex === null ||
        field.activeOptionIndex <= 0
      ) {
        field.activeOptionIndex = 0;
      } else {
        field.activeOptionIndex--;
      }
      this.scrollToActiveOption(field);
    } else if (event.key === 'Enter') {
      event.preventDefault();
      if (
        field.listOpen &&
        field.activeOptionIndex !== undefined &&
        field.activeOptionIndex !== null &&
        field.options &&
        field.options.length > 0
      ) {
        const option = field.options[field.activeOptionIndex];
        if (option) {
          this.selectSearchableOption(field, option);
          field.onChange(option.value);
        }
      } else if (field.onSearchTermChange) {
        field.onSearchTermChange({ target: { value: field.searchTerm } });
      }
    } else if (event.key === 'Escape') {
      field.listOpen = false;
      field.activeOptionIndex = -1;
    }
  }

  scrollToActiveOption(field: any) {
    setTimeout(() => {
      const el = document.getElementById(
        field.name + '-option-' + field.activeOptionIndex
      );
      const el2 = document.getElementById(
        field.name + '-option-' + (field.activeOptionIndex - 1)
      );
      const el3 = document.getElementById(
        field.name + '-option-' + (field.activeOptionIndex + 1)
      );

      el!.scrollIntoView({ block: 'nearest' });
      el!.classList.add('hover', 'bg-blue-100');
      el2?.classList.remove('hover', 'bg-blue-100');
      el3?.classList.remove('hover', 'bg-blue-100');
    }, 0);
  }

  onSearchableSelectFocusIn(field: any) {
    const input = document.getElementById(field.name);
    if (input) {
      (input as HTMLElement).focus();
    }
  }

  onSearchableSelectInput(field: any) {
    const fieldName = field.name;
    const now = Date.now();
    field._lastInputTime = now;
    // Store the current searchTerm and time
    this.lastSearchTermTimes = now;
    // Start a single interval if not already running
    if (!field._searchInterval) {
      field._searchInterval = setInterval(() => {
        // If 1 second has passed since last input and searchTerm hasn't changed, trigger search
        if (Date.now() - field._lastInputTime >= 750) {
          field.onSearchTermChange?.({ target: { value: field.searchTerm } });
          clearInterval(field._searchInterval);
          field._searchInterval = null;
        }
      }, 200);
    }
  }
}
